export default "__VITE_ASSET__0u9KzUMW__"